import React from 'react';
import { useTranslation } from 'react-i18next';
import { AboutContainer, StyledLinkTitle } from './styled';
import { STATIC_PAGES } from '../../../utils/helpers/constants';
import CONFIG from '../../../config';

export const About: React.FC = () => {
  const { t, i18n } = useTranslation();

  const aboutItemsList = [
    {
      title: t('footer.about'),
      path: STATIC_PAGES.ABOUT
    },
    {
      title: t('footer.agreement'),
      path: STATIC_PAGES.TERMS
    },
    {
      title: t('footer.sitemap'),
      path: STATIC_PAGES.SITEMAP
    },
    {
      title: t('footer.privacy'),
      path: STATIC_PAGES.PRIVACY
    },
    {
      title: t('footer.advertise'),
      path: CONFIG.getLandingPageUrl('footer', i18n.language),
      dataStat: 'advertising-landing-footer-btn'
    }
  ];

  return (
    <AboutContainer data-cy="about">
      {aboutItemsList.map(({ title, path, dataStat }, index) => (
        <div data-cy="footer-link-pages" key={index}>
          <StyledLinkTitle
            data-cy="about-title"
            href={path}
            data-stat={dataStat}
          >
            {title}
          </StyledLinkTitle>
        </div>
      ))}
    </AboutContainer>
  );
};
